// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
  height: 4rem;
}
.logo__sm {
  height: 3rem;
}

.searchInMiddle {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 2rem;
  gap: 2rem;
}
@media only screen and (max-width: 56.25em) {
  .searchInMiddle {
    flex-direction: column;
    align-items: center;
  }
  .searchInMiddle_filter {
    order: 2;
  }
  .searchInMiddle_search {
    order: 1;
  }
}

.modal {
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
}
.modal__w38 {
  min-width: 38rem;
  max-width: 100%;
}
.modal__beside {
  display: flex;
  width: 38rem;
  justify-content: space-between;
}
.modal__beside__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  margin-bottom: 2rem;
}
.modal__checks {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
}
.modal__checks_group {
  align-self: center;
}

.whiteTable {
  width: 100%;
  font-size: 1.4rem;
  overflow-y: auto;
  overflow-x: auto;
}
.whiteTable::-webkit-scrollbar:horizontal {
  width: 0;
  height: 0.7rem;
  background: var(--color-white);
}
.whiteTable::-webkit-scrollbar-thumb:horizontal {
  background: var(--color-grey);
  border-radius: 2rem;
}
.whiteTable::-webkit-scrollbar {
  width: 1rem;
  background-color: var(--color-white);
  border-radius: 0 3rem 3rem 0;
}
.whiteTable::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
  border-radius: 3rem;
}
.whiteTable table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
}
.whiteTable table tr {
  padding: 0 1rem;
  align-items: center;
}
.whiteTable table th,
.whiteTable table td {
  padding: 1.2rem 2rem;
}
.whiteTable table th {
  font-weight: 500;
}
.whiteTable table thead {
  padding-bottom: 2rem;
  border-bottom: 1px solid var(--color-grey);
}
.whiteTable table tbody tr {
  background-color: var(--color-white);
}
.whiteTable table .action__text {
  font-weight: 600;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
}
.whiteTable table .action__icons {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 2.4rem;
}
.whiteTable table .action__icons > * {
  cursor: pointer;
  position: relative;
}
.whiteTable table .action__icons > *:hover {
  color: var(--color-primary);
}
.whiteTable table .action__icons > * > :last-child {
  opacity: 0;
}
.whiteTable table .action__icons > * > :last-child:hover {
  opacity: 1;
}
.whiteTable table .action__icons > :not(last-child) {
  margin-right: 0.5rem;
}
.whiteTable table .action__details {
  font-size: 1rem;
  color: var(--color-white);
  padding: 0.8rem;
  background-color: rgba(0, 60, 151, 0.7);
  border-radius: 1rem;
  position: absolute;
  top: -0.7rem;
  left: -1.5rem;
}
.whiteTable table img {
  width: 5rem;
}

.status {
  display: flex;
  font-weight: 700;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  width: 14rem;
  font-size: 1.2rem;
  padding: 0.5rem;
  height: -moz-fit-content;
  height: fit-content;
}
.status__th {
  display: flex;
  justify-content: center;
  width: 14rem;
}
.status__dark__yellow {
  color: var(--color-dark-yellow);
  background-color: var(--color-light-yellow);
  border: 0.5px solid var(--color-dark-yellow);
}
.status__green {
  color: var(--color-green);
  background-color: var(--color-light-green);
  border: 0.5px solid var(--color-green);
}
.status__green2 {
  color: var(--color-green);
  background-color: var(--color-green-3);
  border: 0.5px solid var(--color-green);
}
.status__red {
  color: var(--color-error);
  background-color: var(--color-light-red);
  border: 0.5px solid var(--color-error);
}
.status__grey {
  color: var(--color-grey-2);
  background-color: var(--color-light-grey);
  border: 0.5px solid var(--color-grey-2);
}

.filter_content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.filter_content > :not(last-child) {
  margin-right: 1rem;
}

.noInsights {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-error);
  font-size: var(--default-font-subtitle);
  text-align: center;
  height: 70%;
}

.PhoneInputInput {
  font-size: 1.8rem;
  font-family: inherit;
  color: var(--color-dark);
  padding-left: 2rem;
  height: 4.8rem;
  margin-top: 0.4rem;
  border-radius: 0.8rem;
  background-color: var(--color-white);
  border: 1px solid var(--color-dark);
  display: block;
  box-sizing: border-box;
  outline: none;
}
.PhoneInputInput:focus, .PhoneInputInput:focus-visible, .PhoneInputInput:focus-within {
  color: var(--color-dark);
  border: 2px solid var(--color-dark);
  box-shadow: inset 2px 2px 3px #cad2e1;
}

.container {
  margin-left: auto;
  margin-right: auto;
  max-width: 130rem;
  width: 100%;
  padding: 0 2rem;
}

.fullWidth__border {
  border-bottom: 1px solid var(--color-grey-3);
}

.closing {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  gap: 2rem;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Global/GlobalStyles.scss"],"names":[],"mappings":"AAEA;EACC,YAAA;AADD;AAGC;EACC,YAAA;AADF;;AAKA;EACC,aAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;AAFD;AAIC;EAPD;IAQE,sBAAA;IACA,mBAAA;EADA;EAGA;IACC,QAAA;EADD;EAIA;IACC,QAAA;EAFD;AACF;;AAMA;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AAHD;AAKC;EACC,gBAAA;EACA,eAAA;AAHF;AAMC;EACC,aAAA;EACA,YAAA;EACA,8BAAA;AAJF;AAME;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAJH;AAQC;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;AANF;AAQE;EACC,kBAAA;AANH;;AAWA;EACC,WAAA;EAGA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAVD;AAYC;EACC,QAAA;EACA,cAAA;EACA,8BAAA;AAVF;AAaC;EACC,6BAAA;EACA,mBAAA;AAXF;AAcC;EACC,WAAA;EACA,oCAAA;EACA,4BAAA;AAZF;AAeC;EACC,mCAAA;EACA,mBAAA;AAbF;AAgBC;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AAdF;AAiBE;EACC,eAAA;EACA,mBAAA;AAfH;AAkBE;;EAEC,oBAAA;AAhBH;AAmBE;EACC,gBAAA;AAjBH;AAoBE;EAEC,oBAAA;EACA,0CAAA;AAnBH;AAgCG;EACC,oCAAA;AA9BJ;AAuCG;EACC,gBAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;AArCJ;AAwCG;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;AAtCJ;AAwCI;EACC,eAAA;EACA,kBAAA;AAtCL;AAwCK;EACC,2BAAA;AAtCN;AAyCK;EACC,UAAA;AAvCN;AAyCM;EACC,UAAA;AAvCP;AA4CI;EACC,oBAAA;AA1CL;AA8CG;EACC,eAAA;EACA,yBAAA;EACA,eAAA;EACA,uCAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AA5CJ;AAgDE;EACC,WAAA;AA9CH;;AAmDA;EACC,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;EAAA,mBAAA;AAhDD;AAkDC;EACC,aAAA;EACA,uBAAA;EACA,YAAA;AAhDF;AAmDC;EACC,+BAAA;EACA,2CAAA;EACA,4CAAA;AAjDF;AAoDC;EACC,yBAAA;EACA,0CAAA;EACA,sCAAA;AAlDF;AAqDC;EACC,yBAAA;EACA,sCAAA;EACA,sCAAA;AAnDF;AAsDC;EACC,yBAAA;EACA,wCAAA;EACA,sCAAA;AApDF;AAuDC;EACC,0BAAA;EACA,yCAAA;EACA,uCAAA;AArDF;;AA0DC;EACC,aAAA;EACA,eAAA;EACA,mBAAA;AAvDF;AAyDE;EACC,kBAAA;AAvDH;;AA4DA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uCAAA;EACA,kBAAA;EACA,WAAA;AAzDD;;AA4DA;EACC,iBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,oCAAA;EACA,mCAAA;EACA,cAAA;EACA,sBAAA;EACA,aAAA;AAzDD;AA2DC;EAGC,wBAAA;EACA,mCAAA;EACA,qCAAA;AA3DF;;AA+DA;EACC,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;AA5DD;;AAgEC;EACC,4CAAA;AA7DF;;AAiEA;EACC,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AA9DD","sourcesContent":["@import '../variables/breakpoints';\n\n.logo {\n\theight: 4rem;\n\n\t&__sm {\n\t\theight: 3rem;\n\t}\n}\n\n.searchInMiddle {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: center;\n\tmargin-top: 2rem;\n\tgap: 2rem;\n\n\t@media only screen and (max-width: $bp-900) {\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\t&_filter {\n\t\t\torder: 2;\n\t\t}\n\n\t\t&_search {\n\t\t\torder: 1;\n\t\t}\n\t}\n}\n\n.modal {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\n\t&__w38 {\n\t\tmin-width: 38rem;\n\t\tmax-width: 100%;\n\t}\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\twidth: 38rem;\n\t\tjustify-content: space-between;\n\n\t\t&__grid {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t\tgap: 2rem;\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\t}\n\n\t&__checks {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin: 1rem 0 2rem 0;\n\n\t\t&_group {\n\t\t\talign-self: center;\n\t\t}\n\t}\n}\n\n.whiteTable {\n\twidth: 100%;\n\t// max-height: 100vh;\n\t// margin-top: 3rem;\n\tfont-size: 1.4rem;\n\toverflow-y: auto;\n\toverflow-x: auto;\n\n\t&::-webkit-scrollbar:horizontal {\n\t\twidth: 0;\n\t\theight: 0.7rem;\n\t\tbackground: var(--color-white);\n\t}\n\n\t&::-webkit-scrollbar-thumb:horizontal {\n\t\tbackground: var(--color-grey);\n\t\tborder-radius: 2rem;\n\t}\n\n\t&::-webkit-scrollbar {\n\t\twidth: 1rem;\n\t\tbackground-color: var(--color-white);\n\t\tborder-radius: 0 3rem 3rem 0;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground-color: var(--color-grey);\n\t\tborder-radius: 3rem;\n\t}\n\n\ttable {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tborder: none;\n\t\tborder-collapse: collapse;\n\t\tbox-sizing: border-box;\n\t\ttext-align: left;\n\t\t// margin-top: 2rem;\n\n\t\ttr {\n\t\t\tpadding: 0 1rem;\n\t\t\talign-items: center;\n\t\t}\n\n\t\tth,\n\t\ttd {\n\t\t\tpadding: 1.2rem 2rem;\n\t\t}\n\n\t\tth {\n\t\t\tfont-weight: 500;\n\t\t}\n\n\t\tthead {\n\n\t\t\tpadding-bottom: 2rem;\n\t\t\tborder-bottom: 1px solid var(--color-grey);\n\t\t\t// margin-bottom: 2rem;\n\t\t\t// tr {\n\t\t\t// \tbackground-color: var(--color-dark);\n\t\t\t// \tborder-radius: 1rem;\n\t\t\t// \tcolor: var(--color-white);\n\t\t\t// \tposition: sticky;\n\t\t\t// \ttop: 0;\n\t\t\t// \tz-index: 50;\n\t\t\t// }\n\t\t}\n\n\t\ttbody {\n\t\t\ttr {\n\t\t\t\tbackground-color: var(--color-white);\n\n\t\t\t\t// &:nth-child(even) {\n\t\t\t\t// \tbackground-color: var(--color-table-grey);\n\t\t\t\t// }\n\t\t\t}\n\t\t}\n\n\t\t.action {\n\t\t\t&__text {\n\t\t\t\tfont-weight: 600;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\ttext-decoration: underline;\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\t&__icons {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tfont-size: 2.4rem;\n\n\t\t\t\t&>* {\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tposition: relative;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t\t}\n\n\t\t\t\t\t&> :last-child {\n\t\t\t\t\t\topacity: 0;\n\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&> :not(last-child) {\n\t\t\t\t\tmargin-right: 0.5rem;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&__details {\n\t\t\t\tfont-size: 1rem;\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tpadding: 0.8rem;\n\t\t\t\tbackground-color: rgba(#003c97, 0.7);\n\t\t\t\tborder-radius: 1rem;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: -0.7rem;\n\t\t\t\tleft: -1.5rem;\n\t\t\t}\n\t\t}\n\n\t\timg {\n\t\t\twidth: 5rem;\n\t\t}\n\t}\n}\n\n.status {\n\tdisplay: flex;\n\tfont-weight: 700;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 5px;\n\twidth: 14rem;\n\tfont-size: 1.2rem;\n\tpadding: 0.5rem;\n\theight: fit-content;\n\n\t&__th {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\twidth: 14rem;\n\t}\n\n\t&__dark__yellow {\n\t\tcolor: var(--color-dark-yellow);\n\t\tbackground-color: var(--color-light-yellow);\n\t\tborder: 0.5px solid var(--color-dark-yellow);\n\t}\n\n\t&__green {\n\t\tcolor: var(--color-green);\n\t\tbackground-color: var(--color-light-green);\n\t\tborder: 0.5px solid var(--color-green);\n\t}\n\n\t&__green2 {\n\t\tcolor: var(--color-green);\n\t\tbackground-color: var(--color-green-3);\n\t\tborder: 0.5px solid var(--color-green);\n\t}\n\n\t&__red {\n\t\tcolor: var(--color-error);\n\t\tbackground-color: var(--color-light-red);\n\t\tborder: 0.5px solid var(--color-error);\n\t}\n\n\t&__grey {\n\t\tcolor: var(--color-grey-2);\n\t\tbackground-color: var(--color-light-grey);\n\t\tborder: 0.5px solid var(--color-grey-2);\n\t}\n}\n\n.filter {\n\t&_content {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\talign-items: center;\n\n\t\t&> :not(last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t}\n}\n\n.noInsights {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: var(--color-error);\n\tfont-size: var(--default-font-subtitle);\n\ttext-align: center;\n\theight: 70%;\n}\n\n.PhoneInputInput {\n\tfont-size: 1.8rem;\n\tfont-family: inherit;\n\tcolor: var(--color-dark);\n\tpadding-left: 2rem;\n\theight: 4.8rem;\n\tmargin-top: 0.4rem;\n\tborder-radius: 0.8rem;\n\tbackground-color: var(--color-white);\n\tborder: 1px solid var(--color-dark);\n\tdisplay: block;\n\tbox-sizing: border-box;\n\toutline: none;\n\n\t&:focus,\n\t&:focus-visible,\n\t&:focus-within {\n\t\tcolor: var(--color-dark);\n\t\tborder: 2px solid var(--color-dark);\n\t\tbox-shadow: inset 2px 2px 3px #cad2e1;\n\t}\n}\n\n.container {\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tmax-width: 130rem;\n\twidth: 100%;\n\tpadding: 0 2rem;\n}\n\n.fullWidth {\n\t&__border {\n\t\tborder-bottom: 1px solid var(--color-grey-3);\n\t}\n}\n\n.closing {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-height: 100vh;\n\tgap: 2rem;\n\talign-items: center;\n\tjustify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
